import { IConsuptionOptions } from '../../core/interfaces/consumption.interface';

export class GetConsumptionsAction {
  static readonly type = '[Consumption] Get Consumptions';
  constructor(public payload: IConsuptionOptions) {}
}
